export const GET_BRANCHES = "get_branches";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const GET_VACATION_OVERVIEW = "get_vacation_overview";
export const VACATION_RESET = "vacation_reset";
export const ERROR = "error";
